import http from '../../../../http';
import { SERVER_URL } from '../../../../config';

export const getNavData = (params) => http.get(`${SERVER_URL}/api-main/v1/menu`, {params: {...params}});

export const getAlertsData = (params) => http.get(`${SERVER_URL}/api-main/v1/alerts`, {params: {...params}});
